import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { AccordionPersonForm as AccordionPersonFormVM } from 'shell/view-models/accordion-person-form';

interface AccordionPersonFormProps {
  disabled?: boolean;
  values: AccordionPersonFormVM | null;
  onChange: (
    key: keyof AccordionPersonFormVM,
    value: AccordionPersonFormVM[keyof AccordionPersonFormVM]
  ) => void;
}

const AccordionPersonFormComponent = ({
  disabled,
  values,
  onChange,
}: AccordionPersonFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          fullWidth
          onChange={(event) => {
            onChange('fiscalCode', event?.target.value);
          }}
          value={values?.fiscalCode?.toUpperCase() || ''}
          inputProps={{ maxLength: '16' }}
          disabled={disabled}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} md={10} alignItems="center">
        <Grid item xs={12} md={9}>
          <PmiTextField
            label="Cognome"
            aria-label="Cognome"
            fullWidth
            onChange={(event) => {
              onChange('surname', event?.target.value);
            }}
            disabled={disabled}
            value={values?.surname || ''}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="withoutSurname"
                checked={values?.withoutSurname || false}
                onChange={() => onChange('withoutSurname', !values?.withoutSurname)}
                inputProps={{ 'aria-label': 'Persona senza cognome' }}
                disabled={disabled}
              />
            }
            label="Persona senza cognome"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12} md={10} alignItems="center">
        <Grid item xs={12} md={9}>
          <PmiTextField
            label="Nome"
            aria-label="Nome"
            fullWidth
            disabled={disabled}
            onChange={(event) => {
              onChange('name', event?.target.value);
            }}
            value={values?.name || ''}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="withoutName"
                disabled={disabled}
                checked={values?.withoutName || false}
                onChange={() => onChange('withoutName', !values?.withoutName)}
                inputProps={{ 'aria-label': 'Persona senza nome' }}
              />
            }
            label="Persona senza nome"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

AccordionPersonFormComponent.displayName = 'Accordion person form component';

const AccordionPersonForm = memo(AccordionPersonFormComponent);

export default AccordionPersonForm;
